export const sortByPropKey = <T>(prop: keyof T) => {
  return (a: T, b: T) => {
    const valA = a[prop] !== null ? String(a[prop]).toLowerCase() : '';
    const valB = b[prop] !== null ? String(b[prop]).toLowerCase() : '';
    return valA.localeCompare(valB);
  };
};
